import localforage from "localforage";
import { getCookie, setCookie } from "./cookie";
import {
  getUtmCampaign,
  getUtmMedium,
  getUtmSource,
  setAFCustomerUserId,
  setClevertapProfile,
  setMixpanelProfile,
} from "./events";

const deleteAllCookies = () => {
  var cookies = document.cookie.split(";");

  for (var i = 0; i < cookies.length; i++) {
    var cookie = cookies[i];
    var eqPos = cookie.indexOf("=");
    var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
    document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
  }
};

const getUserToken = () => {
  const token = localStorage.getItem("token");
  // const token = getCookie("token");
  if (token) {
    return token;
  }
  return null;
};

const getUserEmail = () => {
  const email = localStorage.getItem("email");
  // const email = getCookie("email");

  if (email) {
    return email;
  }
  return null;
};

const setUserToken = (token) => {
  if (token) {
    localStorage.setItem("token", token);
    return true;
  }
  return false;
};

const removeUserToken = (token) => {
  localStorage.removeItem("token");
  return true;
};

const removeAllLocalStorageData = () => {
  localStorage.clear();
  sessionStorage.clear();
  deleteAllCookies();
  return true;
};

const setUser = (obj) => {
  return new Promise((resolve, reject) => {

    localforage.setItem("@user", obj, (err, data) => {
      if (err) {
        reject(err);
      } else {
        setUserToken(data.token);
        setClevertapProfile({ email: getUserEmail() });
        setMixpanelProfile({
          email: getUserEmail(),
          utm_source: getUtmSource(),
          utm_medium: getUtmMedium(),
          utm_campaign: getUtmCampaign(),
        });
        resolve(data);
      }
    });
  });
};

const getUser = () => {
  return new Promise((resolve, reject) => {
    localforage.getItem("@user", (err, data) => {
      if (err) {
        reject(err);
      } else if (data === null) {
        reject("user not logged in");
      } else {
        resolve(data);
      }
    });
  });
};

const removeUser = () => {
  return new Promise((resolve, reject) => {
    localforage.clear((error) => {
      if (error) {
        reject(error);
      } else {
        resolve("user removed");
      }
    });
  });
};

// const getUserToken = () => {
//   return new Promise((resolve, reject) => {
//     localforage.getItem("@user", (err, data) => {
//       if (err) {
//         reject(err);
//       } else {
//         resolve(data.token);
//       }
//     });
//   });
// };

export {
  setUser,
  getUser,
  getUserEmail,
  getUserToken,
  setUserToken,
  removeUserToken,
  removeUser,
  removeAllLocalStorageData,
  deleteAllCookies,
};
